/**
 * Automatic client RCA → control-api (durable clientRcaEvents + events.jsonl).
 * Prefer this over browser-only debugLog for anything needed after the tab closes.
 */
import { api } from './api';
import { debugLog } from './debugLog';

export function reportClientRca(
  sessionId: string,
  type: string,
  meta?: Record<string, unknown>,
  message?: string,
): void {
  if (!sessionId) return;
  const short = String(type || '').replace(/^client\./, '');
  const payload = { ...(meta || {}) };
  debugLog(`client.${short}`, payload);
  void api
    .reportClientEvent(sessionId, {
      type: short,
      message: message != null ? String(message).slice(0, 200) : undefined,
      meta: payload,
    })
    .catch(() => undefined);
}
